import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatchingService } from 'src/app/services/matching.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-alerted-list',
  templateUrl: './alerted-list.component.html',
  styleUrls: ['./alerted-list.component.scss']
})
export class AlertedListComponent implements OnInit {

  constructor(private route: ActivatedRoute, private spinner: SpinnerService, private matchingService: MatchingService) { }

  async ngOnInit() {
    await new Promise<void>(async resolve => {
      this.spinner.show();
      const params = this.route.snapshot.queryParams;
      this.jobs = await this.matchingService.batchJobs(params['to'], params['batchid']);
      this.spinner.hide();
      resolve();
    });
  }

  jobs: any[];
}
